import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { delay } from 'lodash';
import {
  Modal, Button,
} from 'react-bootstrap';
import { fetchCommnunicationRecipient, updateCommnunicationRecipient } from '../../../Dashboard/DashboardActions';
import ProgressBar from '../../../../components/progress-bar';
import UserSelector from '../../../../components/user-selector';
import DateTimeDisplay from '../../../../components/date-time-display';

class CommunicationRecipientModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      object: null,
      selectedOwner: null,
      submitting: false,
      success: false,
      errors: null,
      loading: true,
      dirty: false,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
    this.handleUserSelected = this.handleUserSelected.bind(this);
    this.submit = this.submit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.object) {
      const keyAttrName = nextProps.isAccount ? 'account_id' : 'opportunity_id';
      if (!this.props.object || this.props.object[keyAttrName] !== nextProps.object[keyAttrName]) {
        this.setState({
          open: true,
          object: nextProps.object,
          loading: true,
        }, () => {
          this.loadData();
        });
      }
    } else {
      this.setState({ open: false });
    }
  }

  resetForm(success) {
    delay(() => {
      this.setState({ success: false, errors: null });
      if (success) {
        this.props.onSuccess();
      }
    }, 3000);
  }

  loadData() {
    const id = this.props.isAccount ? this.props.object.account_id : this.props.object.opportunity_id;
    this.props.dispatch(fetchCommnunicationRecipient(id, this.props.isAccount))
      .then(
        ({ owner }) => {
          this.setState({ selectedOwner: owner, loading: false });
        },
        () => {

        },
      );
  }

  onExited() {
    this.setState({ selectedOwner: null, object: null, success: false }, () => {
      this.props.onClose();
    });
  }

  close() {
    this.setState({ submitting: false, open: false, object: null, errors: null, dirty: false });
  }

  submit() {
    const { object, isAccount } = this.props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    const { selectedOwner } = this.state;
    this.setState({ submitting: true });
    this.props.dispatch(updateCommnunicationRecipient(id, selectedOwner ? selectedOwner.user_id : null, isAccount))
      .then(
        ({ owner }) => {
          this.setState({ submitting: false, success: true, selectedOwner: owner }, () => {
            this.resetForm(true);
          });
        },
        (errors) => {
          this.setState({ submitting: false, success: false, errors }, () => {
            this.resetForm(false);
          });
        },
      );
  }


  handleUserSelected(selectedId, selectedOwner) {
    this.setState({ selectedOwner: selectedOwner ? {
      ...this.state.selectedOwner,
      ...selectedOwner,
    } : null, dirty: true });
  }

  renderContent() {
    const { isAccount } = this.props;
    const { selectedOwner, submitting, loading } = this.state;
    if (loading) {
      return (<ProgressBar />);
    }
    const objName = isAccount ? 'account' : 'opportunity';
    let updatedInfo = null;
    if (selectedOwner && selectedOwner.user_id && selectedOwner.CommunicationsRecipientId_UpdatedBy && selectedOwner.CommunicationsRecipientId_UpdatedAt) {
      updatedInfo = (
        <div className="text-muted">
          <em>* last updated by <strong>{selectedOwner.CommunicationsRecipientId_UpdatedBy}</strong> at <DateTimeDisplay value={selectedOwner.CommunicationsRecipientId_UpdatedAt} format="shortWithTime" /></em>
        </div>
      );
    }

    return (
      <div>
        <div className="well well-sm">The following user is considered the {objName} owner for this {objName} and will receive all internal communications related to this {objName} (e.g., reminder emails, summary emails, etc.).</div>

        <div>
          <UserSelector
            label={`${objName} Communications Owner`}
            disabled={submitting}
            onSelect={this.handleUserSelected}
            query={{ isStandardUser: true }}
            userId={selectedOwner ? selectedOwner.user_id : null}
          />
        </div>
        {updatedInfo}
      </div>
    );
  }

  renderError() {
    const { errors } = this.state;
    let message = 'Internal Server Error';
    if (errors && errors.data && errors.data.message) {
      ({ message } = errors.data);
    } else if (errors && errors.statusText) {
      message = errors.statusText;
    }
    return (
      <div className="animated flash alert alert-danger">
        {message}
      </div>
    );
  }

  render() {
    const {
      open, object, submitting, success,
      errors, dirty,
    } = this.state;
    const { isAccount } = this.props;
    const keyAttr = isAccount ? 'account_id' : 'opportunity_id';

    const hasObject = object && object[keyAttr];
    const props = {};

    if (hasObject) {
      props[keyAttr] = object[keyAttr];
    }
    const hasErrors = errors !== null;

    return (
      <Modal
        show={open}
        onHide={this.close}
        onExited={this.onExited}
      >
        {hasObject &&
          <Modal.Header closeButton>
            <Modal.Title>Recipient for Internal Communications for {object.name}</Modal.Title>
          </Modal.Header>
        }
        {open && hasObject &&
          <Modal.Body>
            <div>
              {!success && !hasErrors && this.renderContent()}
              {success && <div className="animated flash alert alert-success">Communication Recipient updated!</div>}
              {!success && hasErrors && this.renderError()}
            </div>
          </Modal.Body>
        }
        <Modal.Footer>
          {!success && !hasErrors &&
            <div className="clearfix">
              <Button bsStyle="link" className="pull-left" onClick={this.close}>Cancel</Button>
              {dirty && 
                <Button
                  bsStyle="primary"
                  disabled={submitting}
                  onClick={this.submit}
                >
                  Save
                </Button>
              }
            </div>
          }
          {(success || hasErrors) && <Button bsStyle="link" onClick={this.close}>{(success ? 'Done' : 'Cancel')}</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

CommunicationRecipientModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  object: PropTypes.shape({}),
  onClose: PropTypes.func,
  isAccount: PropTypes.bool,
  onSuccess: PropTypes.func,
};
CommunicationRecipientModal.defaultProps = {
  isAccount: false,
  object: null,
  onClose: () => {},
  onSuccess: () => {},
};
CommunicationRecipientModal.contextTypes = {
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(CommunicationRecipientModal);
